export const QUOTATION_FORM_SECTION_ID = 'quotation-form-section';
export const QUOTATION_FORM_ID = 'product-quotation-form';

export const MAX_FORM_ADULTS = 6;
export const MAX_FORM_KIDS = 6;
export const MAX_FORM_TEENS = 6;
export const MIN_FORM_ADULTS = 1;
export const MIN_FORM_KIDS = 0;
export const MIN_FORM_TEENS = 1;
export const NO_VALUE = 'NO';
export const RANGE_ESCAPADE = 'escapade';
